import { Block, Text } from "@convertkit/slate"

const normalizeInlinesInsideLists = (editor, error) => {
  if (
    error.node.nodes.every(
      node => node.object === "text" || node.object === "inline"
    )
  ) {
    const nodes = error.node.nodes

    editor.withoutNormalizing(() => {
      nodes.forEach(node => {
        editor.removeNodeByKey(node.key)
      })

      const list_item = Block.create({
        type: "list-item",
        nodes: [
          Block.create({
            type: "list-item-child",
            nodes
          })
        ]
      })

      editor.insertNodeByKey(error.node.key, 0, list_item)
    })
  }
}

export default ({ blocks }) => {
  return {
    blocks: {
      [blocks.unordered_list]: {
        nodes: [
          {
            match: { type: blocks.list_item }
          }
        ],
        normalize: (editor, error) => {
          normalizeInlinesInsideLists(editor, error)
        }
      },
      [blocks.ordered_list]: {
        nodes: [
          {
            match: { type: blocks.list_item }
          }
        ],
        normalize: (editor, error) => {
          normalizeInlinesInsideLists(editor, error)
        }
      },
      [blocks.list_item]: {
        parent: [
          { type: blocks.unordered_list },
          { type: blocks.ordered_list }
        ],
        nodes: [
          {
            match: { type: blocks.list_item_child },
            min: 1,
            max: 1
          },
          {
            match: [
              { type: blocks.unordered_list },
              { type: blocks.ordered_list }
            ],
            min: 0,
            max: 1
          }
        ],
        normalize: (editor, error) => {
          switch (error.code) {
            case "child_min_invalid":
              editor.insertNodeByKey(
                error.node.key,
                0,
                Block.create({
                  type: blocks.list_item_child,
                  nodes: [Text.create()]
                })
              )
              return
            case "child_type_invalid": {
              editor.wrapBlockByKey(error.child.key, {
                type: blocks.list_item_child
              })
              return
            }
            case "parent_type_invalid":
              editor.wrapBlockByKey(error.node.key, blocks.unordered_list)
              return
            default:
              return
          }
        }
      }
    }
  }
}
